module.exports = __webpack_public_path__ + "img/close-64.51ac5d74.png";